import type { FC, ReactNode } from 'react'

import Image from 'next/image'

import { Reveal } from '@/components/generals/reveal'
import { Section } from '@/components/generals/section'
import { SectionHeading } from '@/components/generals/section-heading'
import { testimonials } from '@/constants/content'

export const Testimonials: FC = (): ReactNode => {
    return (
        <Section id='testimonials'>
            <SectionHeading
                eyebrow='Testimonials'
                segments={[
                    { text: 'There’s a reason people are' },
                    { text: 'raving', serif: true },
                    { text: 'about us.' }
                ]}
            />

            <Reveal
                y={26}
                blur={10}
                delay={0.1}
                stagger={0.08}
                className='mt-14 grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:mt-20 lg:grid-cols-3'
            >
                {testimonials.map((testimonial) => (
                    <figure
                        key={testimonial.name}
                        className='flex h-full flex-col justify-between gap-7 rounded-2xl bg-surface-1 p-6 ring-1 ring-white/8 transition-all duration-500 ease-[cubic-bezier(0.44,0,0.56,1)] hover:-translate-y-1 hover:bg-surface-2 hover:ring-white/16'
                    >
                        <blockquote className='text-[15px] leading-[1.5] tracking-[-0.02em] text-white/56'>
                            {testimonial.quote}
                        </blockquote>

                        <figcaption className='flex items-center gap-3'>
                            <span className='relative size-10 shrink-0 overflow-hidden rounded-full ring-1 ring-white/10'>
                                <Image
                                    src={testimonial.image}
                                    alt={`Portrait of ${testimonial.name}`}
                                    fill
                                    sizes='40px'
                                    className='object-cover'
                                />
                            </span>

                            <span className='flex flex-col gap-0.5'>
                                <span className='text-sm leading-[1.4] font-medium tracking-[-0.02em] text-white'>
                                    {testimonial.name}
                                </span>

                                <span className='text-sm leading-[1.4] tracking-[-0.02em] text-white/40'>
                                    {testimonial.role}
                                </span>
                            </span>
                        </figcaption>
                    </figure>
                ))}
            </Reveal>
        </Section>
    )
}
